import React, { useState } from "react";
import { Offcanvas, Button, ListGroup } from "react-bootstrap";

const CategoryDrawer = ({
  show,
  onHide,
  selectedType,
  setSelectedType,
  accessoryType,
  setAccessoryType,
}) => {
  const [showAccessories, setShowAccessories] = useState(false);

  const handleCategorySelect = (category) => {
    if (category === "Accessories") {
      setShowAccessories(true);
      setSelectedType(category);
    } else {
      setSelectedType(category);
      setShowAccessories(false);
      onHide();
    }
  };

  const handleAccessorySelect = (type) => {
    setAccessoryType(type);
    onHide();
  };

  return (
    <Offcanvas show={show} onHide={onHide} backdrop='static'>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Select Product Category</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {!showAccessories ? (
          <ListGroup>
            <ListGroup.Item
              action
              active={selectedType === "Eyeglasses"}
              onClick={() => handleCategorySelect("Eyeglasses")}
            >
              Eyeglasses
            </ListGroup.Item>
            <ListGroup.Item
              action
              active={selectedType === "Sunglasses"}
              onClick={() => handleCategorySelect("Sunglasses")}
            >
              Sunglasses
            </ListGroup.Item>
            <ListGroup.Item
              action
              active={selectedType === "Contactlens"}
              onClick={() => handleCategorySelect("Contactlens")}
            >
              Contact Lens
            </ListGroup.Item>
            <ListGroup.Item
              action
              active={selectedType === "Framelens"}
              onClick={() => handleCategorySelect("Framelens")}
            >
              Frame Lens
            </ListGroup.Item>
            <ListGroup.Item
              action
              active={selectedType === "Accessories"}
              onClick={() => handleCategorySelect("Accessories")}
            >
              Accessories
            </ListGroup.Item>
            <ListGroup.Item
              action
              active={selectedType === "BrandsImage"}
              onClick={() => handleCategorySelect("BrandsImage")}
            >
              Brand Images
            </ListGroup.Item>
          </ListGroup>
        ) : (
          <>
            <Button
              variant='outline-secondary'
              className='mb-3'
              onClick={() => setShowAccessories(false)}
            >
              ← Back to Categories
            </Button>

            <h5>Select Accessory Type</h5>
            <ListGroup>
              <ListGroup.Item
                action
                active={accessoryType === "Solution"}
                onClick={() => handleAccessorySelect("Solution")}
              >
                Solution
              </ListGroup.Item>
              <ListGroup.Item
                action
                active={accessoryType === "LensCase"}
                onClick={() => handleAccessorySelect("LensCase")}
              >
                Lens Case
              </ListGroup.Item>
              <ListGroup.Item
                action
                active={accessoryType === "LensCleaner"}
                onClick={() => handleAccessorySelect("LensCleaner")}
              >
                Lens Cleaner
              </ListGroup.Item>
              <ListGroup.Item
                action
                active={accessoryType === "ClipOns"}
                onClick={() => handleAccessorySelect("ClipOns")}
              >
                Clip-Ons
              </ListGroup.Item>
            </ListGroup>
          </>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default CategoryDrawer;
